import QuestionBreakdownReport from './QuestionsBreakdownReport';
import { useLocation } from 'react-router-dom';
import { useGetCumulativeAssignmentReportWithRetakesMutation } from '../../../../../../features/authentication/reportApiSlice';

const StudentRetakeReport = () => {
  const location = useLocation();
  const { studentId, selectedClassId } = location.state;
  const [getCumulativeAssignmentReportWithRetakes] = useGetCumulativeAssignmentReportWithRetakesMutation();

  return (
    <QuestionBreakdownReport
      includeRetakeData={true}
      studentId={studentId}
      initialClassId={selectedClassId}
      reportTitle='Student Retake Report'
      exportFileName='StudentRetakeReport'
      reportDataEndpoint={getCumulativeAssignmentReportWithRetakes}
      goBackOnError={true}
      />
  );

};

export default StudentRetakeReport;